import Vue from 'vue'
import * as pages from '@/assets/data/report.json'

export const siteUrl = 'https://landing.adobe.com/en/na/products/experience-cloud/ctir-3861-mobile-study/index.html'
export const encUrl = encodeURIComponent( siteUrl )
export const siteDesc = 'A report on the state of mobile maturity, ten years after smartphones changed our lives forever'
export const encDesc = encodeURIComponent( siteDesc )
export const siteTitle = 'Adobe 2018 Mobile Study'
export const encTitle = encodeURIComponent( siteTitle )

export const colors = [
  { main: '#5605EC', accent: '#FF0000' },
  { main: '#00D692', accent: '#001A93' },
  { main: '#5605EC', accent: '#00D6D2' },
  { main: '#FF3737', accent: '#961B98' },
  { main: '#DA0F9A', accent: '#03CDD2' },
  { main: '#001A93', accent: '#FFA1A1' }
]

export const gnavHeightMobile = 60
export const gnavHeightTablet = 80

export const ua = window.navigator.userAgent
export const isiOS = /iPad|iPhone|iPod/.test( ua )
export const isAndroid = /android/i.test( ua )

export const geolocKey = 'AIzaSyCA_JkSA96s9NtNSNEA68c-vnkHZpp2kFw'

export const baseDesignWidth = 375

export const footIntroH = 250

export const dataTransTime = 2.5

export const industryTypes = {
  mktg: {
    id: 'mktg',
    displayName: 'Marketing',
    shortName: 'Marketing',
    membersName: 'Marketers',
    demoClass: ''
  },
  it: {
    id: 'it',
    displayName: 'Information<br>Technology',
    shortName: 'IT',
    membersName: 'IT',
    demoClass: 'white'
  }
}

export const reportLengths = {
  short: 0,
  long: 1
}

export const reportTxtStyles = {
  default: 0,
  extended: 1
}

export const Bus = new Vue()

export const reportData = pages
export const pdfUrl = reportData[ (reportData.length - 1) ].foot.pdfURL



// WEBPACK FOOTER //
// ./src/lib/consts.js